import { navigateTo, YesNoToBoolean } from "../../helper";
import queryString from "query-string";
import RouteNames from "../../routes/type";
import { ClaimState } from "./types";

export const formatPhoneNumber = (input: string): string => {
  const numericInput = input.replace(/[^0-9]/g, "");
  if (!numericInput || numericInput?.length !== 10) {
    return null;
  }
  const areaCode = numericInput.slice(0, 3);
  const firstPart = numericInput.slice(3, 6);
  const secondPart = numericInput.slice(6);
  return `(${areaCode}) ${firstPart}-${secondPart}`;
};

export const nextStepRedirect = (extarProps = {}, step = null) => {
  const parsed = queryString.parse(window.location.search);
  step ||= parseInt(parsed.step.toString()) + 1;
  window.scrollTo(0, 0);
  navigateTo(
    `/${RouteNames.CREATE_CLAIM}?${queryString.stringify({
      ...parsed,
      ...extarProps,
      step,
    })}`
  );
};

export const mapCustomerInfoToApi = (state: ClaimState) => {
  const customerInfo = state.customerInfo;
  return {
    ...(state.id ? { id: state.id } : {}),
    status: "New Claim",
    First_Name: customerInfo.first_name || "",
    Last_Name: customerInfo.last_name || "",
    claim_communications_email: customerInfo.email || "",
    claim_communications_phone: customerInfo.number || "",
    Address_1: customerInfo.address1 || "",
    Address_2: customerInfo.address2 || "",
    City: customerInfo.city || "",
    State: customerInfo.state || "",
    Zip: customerInfo.zip || "",
    sms_consent: !!customerInfo.allowSMS,
  };
};

export const mapApiClaimData = (state: ClaimState) => {
  const customerInfo = state.customerInfo;
  const purchaseInfo = state.purchaseInfo;
  const damageInfo = state.damageInfo;
  const documents = state.documents;

  return {
    ...(state.id ? { id: state.id } : {}),
    First_Name: customerInfo.first_name || "",
    Last_Name: customerInfo.last_name || "",
    claim_communications_email: customerInfo.email || "",
    claim_communications_phone: customerInfo.number || "",
    Address_1: customerInfo.address1 || "",
    Address_2: customerInfo.address2 || "",
    City: customerInfo.city || "",
    State: customerInfo.state || "",
    Zip: customerInfo.zip || "",
    sms_consent: !!customerInfo.allowSMS,
    //
    Store_of_Purchase: purchaseInfo.store_purchase || "",
    Retailer_Phone: purchaseInfo.retailer_phone || "",
    Retailer_Address_1: purchaseInfo.address1 || "",
    Retailer_Address_2: purchaseInfo.address2 || "",
    Retailer_City: purchaseInfo.city || "",
    Retailer_State: purchaseInfo.state || "",
    Retailer_Zip: purchaseInfo.zip || "",
    mattress_purchase_date: purchaseInfo.purchase_date || "",
    invoice: purchaseInfo.invoice_number || "",
    Invoice_Image: purchaseInfo.invoice_image,
    //
    incident_date: damageInfo.date_incident || "",
    protector_product_type: damageInfo.product_type || "",
    Product_Size: damageInfo.product_size || "",
    Mattress_Stained_Damaged: YesNoToBoolean(
      damageInfo.mattress_stained_damaged
    ),
    Protector_Encasement_Stained_Damaged: YesNoToBoolean(
      damageInfo.protector_damage
    ),
    Type_of_Mattress_Stain_Damage: damageInfo.type_of_stain_damage || "",
    Type_of_Stain_Damage_Protector: damageInfo.damage_Protector_type || "",
    damage_description: damageInfo.damageNotes || "",
    Estimated_Mattress_Retail_Value: damageInfo.estimated_retail_value || "",
    mattress_manufacturer: damageInfo.mattress_manufacturer || "",
    mattress_model: damageInfo.mattress_model || "",
    mattress_product: damageInfo.mattress_product || "",
    Did_you_clean_the_product: YesNoToBoolean(damageInfo.did_clean_product),
    Was_the_Protector_Encasement_on_bed_during_inciden: YesNoToBoolean(
      damageInfo.protector_on_bed
    ),
    protector_damage_images:
      documents.protector_damage_images.join("\n\n") || "",
    mattress_damage_images: documents.mattress_damage_images.join("\n\n") || "",
    protectall_tag_image: documents.protectall_tag_image || "",
  };
};

export const makeHTMLContentForTicket = (data: ClaimState, claimName) => {
  const labels = {
    first_name: "First Name",
    last_name: "Last Name",
    email: "Email",
    phone_number: "Phone Number",
    address_1: "Address 1",
    address_2: "Address 2",
    city: "City",
    state: "State",
    zip: "Zip Code",
    store_purchase: "Store of Purchase",
    retailer_phone: "Retailer Phone",
    retailer_address_1: "Retailer Address 1",
    retailer_address_2: "Retailer Address 2",
    retailer_city: "Retailer City",
    retailer_state: "Retailer State",
    retailer_zip: "Retailer Zip",
    purchase_date: "Purchase Date",
    invoice_number: "Invoice Number",
    invoice_image: "Invoice Image",
    date_of_incident: "Date of Incident",
    product_size: "Product Size",
    product_type: "Product Type",
    mattress_stained_damaged: "Mattress Stained/Damaged",
    type_of_stain_damage: "Type of Stain/Damage",
    protector_damage: "Protector/Encasement Stained/Damaged",
    damage_Protector_type: "Type of Stain/Damage (Protector)",
    estimated_retail_value: "Estimated Mattress Retail Value",
    did_clean_product: "Did You Clean the Protector/Encasement?",
    protector_on_bed: "Encasement on Bed at Time of Incident?",
    damageNotes: "Damage Notes",
    protector_damage_images: "Protector Damage Images",
    mattress_damage_images: "Mattress Damage Images",
    protectall_tag_image: "ProtectAll Tag Image",
    mattress_manufacturer: "Mattress Manufacturer",
    mattress_model: "Mattress Model",
    mattress_product: "Mattress Size",
  };

  const getValue = (value) => {
    value ||= "";
    value = value.toString();
    return value.startsWith("https://")
      ? value.toLowerCase().endsWith(".pdf")
        ? `<a href="${value}"><img src="https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg" style="width: 64px; height: 64px; border-radius: 4px; object-fit: contain;margin-right:8px;"></a>`
        : `<a href="${value}"><img src="${value}" style="width: 64px; height: 64px; border-radius: 4px; object-fit: cover;margin-right:8px;"></a>`
      : value || false;
  };

  const renderRow = (key, value) => {
    const fomrattedValue = Array.isArray(value)
      ? value.length > 0
        ? value.map(getValue).join("")
        : false
      : getValue(value);

    if (fomrattedValue)
      return `<tr><td style="font-weight: 500; padding: 4px; width:300px;"><strong>${
        labels[key] || key
      }</strong></td><td style="padding:4px;">${fomrattedValue}</td></tr>`;
  };

  const renderSection = (title, content) =>
    `<div style="background: rgba(243, 248, 254, 0.8); padding: 4px 8px; border: 1px solid #ccc; border-radius: 8px; margin-bottom: 10px;">
      <p style="font-weight: bold; font-size: 18px; color: black; margin-bottom: 10px;">${title}</p>
      <table style="width: 100%; border-collapse: separate; border-spacing: 0 10px; font-size: 14px; color: black;">
        ${content}
      </table>
    </div>`;

  const customerDetails = [
    "first_name",
    "last_name",
    "email",
    "phone_number",
    "address_1",
    "address_2",
    "city",
    "state",
    "zip",
  ]
    .map((key) => renderRow(key, data.customerInfo[key]))
    .join("");

  const purchaseDetails = [
    ["store_purchase"],
    ["retailer_phone"],
    ["address1", "retailer_address_1"],
    ["address2", "retailer_address_2"],
    ["city", "retailer_city"],
    ["state", "retailer_state"],
    ["zip", "retailer_zip"],
    ["purchase_date"],
    ["invoice_number"],
    ["invoice_image"],
  ]
    .map((key) => renderRow(key[1] || key[0], data.purchaseInfo[key[0]]))
    .join("");

  const damageDetails = [
    "date_of_incident",
    "product_size",
    "product_type",
    "mattress_stained_damaged",
    "type_of_stain_damage",
    "protector_damage",
    "damage_Protector_type",
    "estimated_retail_value",
    "did_clean_product",
    "protector_on_bed",
    "mattress_manufacturer",
    "mattress_model",
    "mattress_product",
    "damageNotes",
    "protector_damage_images",
    "mattress_damage_images",
    "protectall_tag_image",
  ]
    .map((key) =>
      renderRow(key, data?.damageInfo?.[key] || data?.documents?.[key])
    )
    .join("");

  return `<div style="font-family: Arial, sans-serif; background-color: #fff;">
    <div style="max-width: 600px; margin: auto;">
    <div style="background: rgba(243, 248, 254, 0.8); padding: 12px; border: 1px solid #ccc; border-radius: 8px; margin-bottom: 5px;">
      <p style="font-weight: bold; font-size: 24px; color: black;text-align:center;margin:0px">${claimName}</p>
    </div>
      ${renderSection("Customer Information", customerDetails)}
      ${renderSection("Purchase Information", purchaseDetails)}
      ${renderSection("Damage Details", damageDetails)}
    </div>
  </div>`;
};

export const mapZohoToDocuments = (zohoData: any) => ({
  protector_damage_images: zohoData?.protector_damage_images
    ? zohoData.protector_damage_images.split("\n\n").filter(Boolean)
    : [],
  mattress_damage_images: zohoData?.mattress_damage_images
    ? zohoData.mattress_damage_images.split("\n\n").filter(Boolean)
    : [],
  protectall_tag_image: zohoData?.protectall_tag_image || "",
});

export const mapStoreKeyToZohoField = (storeKeyName: string) => {
  const map: Record<string, string> = {
    "purchaseInfo.invoice_image": "Invoice_Image",
    "documents.invoice_image": "Invoice_Image", // in case it's still somewhere
    "documents.protector_damage_images": "protector_damage_images",
    "documents.mattress_damage_images": "mattress_damage_images",
    "documents.protectall_tag_image": "protectall_tag_image",
  };
  return map[storeKeyName] || storeKeyName;
};
